import numeral from 'numeral';

export const parseCurrency = (value, previousValue) => {
  if (!value) {
    return value;
  }

  return Number(numeral(value).format('0'));
};
